import styled from "styled-components";

const BodyStyles = styled.div`
  padding: ${({ theme }) => theme.spacing[24]};
`;

const Body = ({ children, style, className }) => (
  <BodyStyles style={{ ...style }} className={className}>
    {children}
  </BodyStyles>
);

export default Body;
